export const defaultRTMSTreatmentOperators: { [key: string]: string } = {
  pulseIntensity: '-',
  numberOfPulses: '+',
  electricFieldStrength: '-',
};
